'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIMILAR_TITLES = _constantsAnalytics2.default.CATEGORIES.SIMILAR_TITLES;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS,
    ADD_SIMILAR_TITLE = _analyticsConstants$E.ADD_SIMILAR_TITLE,
    REMOVE_SIMILAR_TITLE = _analyticsConstants$E.REMOVE_SIMILAR_TITLE;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS,
    ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;


function composeSimilarTitlesEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: SIMILAR_TITLES,
    gtmAction: action
  });
}

function composeAddSimilarTitlesEvent() {
  return (0, _compose.composeAnalytics)([composeSimilarTitlesEvent(ADD_SIMILAR_TITLE, ADD_CONTENT)]);
}

function composeRemoveSimilarTitlesEvent() {
  return (0, _compose.composeAnalytics)([composeSimilarTitlesEvent(REMOVE_SIMILAR_TITLE, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddSimilarTitlesEvent: composeAddSimilarTitlesEvent,
  composeRemoveSimilarTitlesEvent: composeRemoveSimilarTitlesEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/similarTitlesEventComposer.js
// module id = 558
// module chunks = 0 2 4 6 7 8 9 10